// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"dc0790a0","453":"b2ef52fb","796":"2a14bc1c"}[chunkId] + ".chunk.js";
};